import {
  Box,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { useToastSaurus } from "../../../../../../service/app/use-cases";
import { Paginacao } from "../../../../../components/paginacao/paginacao";
import { useDefaultSincronizacaoStyles } from "../../sincronizacao-styles";
import { SincronizacaoListData } from "./sincronizacao-list-data";
import { SincronizacaoListSearchProps } from "./sincronizacao-list-search-props";
import { isEmpty } from "lodash";
import { useGetSincronizacaoDados } from "../../../../../../data/api/gestao/sincronizacao-dados/get-sincronizacao-dados";
import { CircularLoading } from "../../../../../components";
import { SincronizacaoDadosModel } from "../../../../../../model/api/sincronizacao/sincronizacao-dados-model ";
import { CardNaoEncontrado } from "../../../../../components/cards/card-nao-encontrado";
import { InformacaoIcon } from "../../../../../components/icons";

export interface SincronizacaoListProps {
  searchProps: SincronizacaoListSearchProps;
}
export default function SincronizacaoList(props: SincronizacaoListProps) {
  const classes = useDefaultSincronizacaoStyles();
  const { getSincronizacaoDados, carregando } = useGetSincronizacaoDados();
  const { showToast } = useToastSaurus();

  const [queryStatus, setQueryStatus] = useState({
    page: 1,
    totalPages: 0,
    totalResults: 0,
    list: Array<SincronizacaoDadosModel>(),
  });
  const fillResult = useCallback(
    async (
      page: number,
      totalPages: number,
      totalResults: number,
      list: Array<SincronizacaoDadosModel>
    ) => {
      setQueryStatus({
        page: page,
        list: list,
        totalResults: totalResults,
        totalPages: totalPages,
      });
    },
    []
  );
  const [selectedList, setSelectedList] = useState<Array<string>>([]);

  const search = useCallback(
    async (newPage: number) => {
      try {
        const query =
          "" +
          (props.searchProps.aplicacao && props.searchProps.aplicacao !== '0'  
            ? "&codAplicacao=" + props.searchProps.aplicacao
            : "") +
          (props.searchProps.dataInicio
            ? "&dataInicial=" + props.searchProps.dataInicio
            : "") +
          (props.searchProps.dataFinal
            ? "&dataFinal=" + props.searchProps.dataFinal
            : "");
        const res = await getSincronizacaoDados(
          props.searchProps.lojaId,
          newPage,
          query
        );
        if (res.erro) throw res.erro;

        if (
          res.resultado?.data?.pageIndex > res.resultado?.data?.totalPage &&
          res.resultado?.data?.totalResult > 0
        ) {
          search(res.resultado?.data?.totalPage);
          return;
        }

        fillResult(
          res.resultado?.data?.pageIndex,
          res.resultado?.data?.totalPage,
          res.resultado?.data?.totalResult,
          res.resultado?.data?.results
        );
      } catch (e: any) {
        showToast("error", e.message);
      }
    },
    [
      props.searchProps.lojaId,
      props.searchProps.aplicacao,
      props.searchProps.dataInicio,
      props.searchProps.dataFinal,
      getSincronizacaoDados,
      fillResult,
      showToast,
    ]
  );

  const pageChanged = useCallback(
    async (newPage: number) => {
      if (newPage <= queryStatus.totalPages || newPage > 0) {
        search(newPage);
      }
    },
    [queryStatus.totalPages, search]
  );

  const onCardChecked = (id: string) => {
    const aux = [...selectedList];
    aux.push(id);
    setSelectedList(aux);
  };

  useEffect(() => {
    if (props.searchProps.lojaId) {
      search(queryStatus.page);
    }
  }, [queryStatus.page, search, props.searchProps]);

  return (
    <>
      <div className={classes.defaultContainer}>
        {carregando && <CircularLoading tipo="FULLSIZED" />}
        <Box className={classes.container}>
          <Grid container style={{ flex: "0 1 auto", overflowY: "auto" }}>
            <Grid item xs={12}>
              <Paginacao
                pageChanged={pageChanged}
                totalPages={queryStatus.totalPages}
                totalRegisters={queryStatus.totalResults}
                currentPage={queryStatus.page}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Card className={classes.cardRoot}>
                <Box p={2}>
                  {!isEmpty(props.searchProps.lojaNome) && (
                    <Toolbar className={classes.containerNameLoja}>
                      <Typography className={classes.titleLoja}>
                        {props.searchProps.lojaNome}
                      </Typography>
                    </Toolbar>
                  )}
                  <Grid className={classes.card}>
                    {(queryStatus.list.length === 0 && !carregando) && (
                      <CardNaoEncontrado
                        mensagem="Nenhuma informação encontrada."
                        icon={<InformacaoIcon tipo="GERAL" />}
                      />
                    )}
                    {queryStatus.list.length > 0 && !carregando && (

                      <TableContainer component={Paper} className={classes.tableContainerHeaderFixed}>
                        <Table className={classes.table} aria-label="sticky table" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell align='center'>
                                Aplicação
                              </TableCell>
                              <TableCell align='center'>
                                Usuário
                              </TableCell>
                              <TableCell align='center'>
                                Total de Produtos
                              </TableCell>
                              <TableCell align='center'>
                                (%) Concluído
                              </TableCell>
                              <TableCell align='center'>
                                Data Envio
                              </TableCell>
                              <TableCell align='center'>
                                Data Conclusão
                              </TableCell>
                              <TableCell align='center'>
                                Situação
                              </TableCell>
                              <TableCell>
                                Download
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <SincronizacaoListData
                              onCardChecked={onCardChecked}
                              lojaId={props.searchProps.lojaId}
                              list={queryStatus.list}
                              selectedList={selectedList}
                              carregando={carregando}
                            />
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Grid>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
}
